export default "__VITE_ASSET__KJzu21_5__"